export default __webpack_public_path__ + "static/media/proactive.798f7a1a.svg";